import { Link } from "react-router-dom";
import { Snowflake, ArrowRight } from "lucide-react";

// Slim seasonal top bar for the landing — for visitors who never scroll.
// Shows September through 3 January (Christmas trip-planning season).
function isChristmasWindow(now = new Date()) {
  const month = now.getMonth() + 1; // 1-12
  const day = now.getDate();
  return month >= 9 || (month === 1 && day <= 3);
}

export const ChristmasTopBar = () => {
  if (!isChristmasWindow()) return null;
  return (
    <Link
      to="/christmas"
      data-testid="christmas-topbar"
      className="block bg-[#7A1420] text-white hover:bg-[#8d1a28] transition-colors"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-2.5 text-center">
        <p className="font-body font-700 text-xs md:text-sm">
          <Snowflake size={13} className="inline-block -mt-0.5 mr-1.5 text-[#FDE047]" />
          Christmas in Copenhagen — markets &amp; gløgg.{" "}
          <span className="font-800 text-[#FDE047] whitespace-nowrap">
            The guide <ArrowRight size={13} className="inline-block -mt-0.5" />
          </span>
        </p>
      </div>
    </Link>
  );
};
